<!-- Heading -->
<div
	class="mt-5"
	[innerHTML]="content.introContent | ngSafeHTML"
	ngRouterLinkTransformer
></div>

<!-- Cookie Settings -->
<legal-cookies-settings
	[showDescriptions]="content.showSettingsDescriptions ?? true"
	(socialMediaCookiesChange)="saveSocialMediaOptions($event)"
	(analyticalCookiesChange)="saveAnalyticsOptions($event)"
></legal-cookies-settings>

<!-- Explaining Text -->
<div
	class="mt-5"
	[innerHTML]="content.usageContent | ngSafeHTML"
	ngRouterLinkTransformer
></div>
